import SocialBarApp from '../SocialBarApp/SocialBarApp';
import React from 'react';
import PropTypes from 'prop-types';
import BI from '@wix/wixrest-bi/dist/BI';
import WixInstance from '@wix/wixrest-utils/dist/WixInstance';
import I18n from '@wix/wixrest-utils/dist/I18n';

const { i18n, I18N_EXTERNAL } = I18n.getComponentHeader('restaurants-socialbar');

export default React.createClass({
    propTypes: {
        organization: PropTypes.object.isRequired,
        socialBarState: PropTypes.object.isRequired,
        socialBarActions: PropTypes.object.isRequired
    },

    componentDidMount() {
        let { socialBarActions } = this.props;

        socialBarActions.initState();

        if (this._isOnEditorOrPreview()) {
            this._setResizeEvent();
        }

        this._onResize();
    },

    componentWillUnmount() {
        if (this._isOnEditorOrPreview()) {
            this._cancelResizeEvent();
        }
    },

    componentWillReceiveProps(nextProps) {
        let isOnEditorOrPreview = this._isOnEditorOrPreview(nextProps);
        if (!this.listenToResize && isOnEditorOrPreview) {
            this._setResizeEvent();
        } else if (this.listenToResize && !isOnEditorOrPreview) {
            this._cancelResizeEvent();
        }
    },

    render() {
        let { organization, socialBarState } = this.props;

        return (
            <SocialBarApp
                externalIds={organization.externalIds}
                socialBarState={socialBarState}
                i18n={{i18n, I18N_EXTERNAL}}
                onClick={this._onLinkClick}
                locale={organization.locale} />
        );
    },

    _onLinkClick(id) {
        if (!this._isOnEditor()) {
            BI.event(BI.EVENTS.LIVE_SITE_OLO_SOCIAL_CLICK, {
                platform: id,
                is_merchant: WixInstance.getPermissions() === 'owner',
                visitorId: WixInstance.getUserId() || ''
            });
        }
    },

    _setResizeEvent() {
        window.onresize = this._onResize.bind(this);
        this.listenToResize = true;
    },

    _cancelResizeEvent() {
        window.onresize = null;
        this.listenToResize = false;
    },

    _isOnEditor(newProps) {
        let props = newProps || this.props;
        let { socialBarState } = props;
        return socialBarState.viewMode === 'editor';
    },

    _isOnPreview(newProps) {
        let props = newProps || this.props;
        let { socialBarState } = props;
        return socialBarState.viewMode === 'preview';
    },

    _isOnEditorOrPreview(newProps) {
        return this._isOnEditor(newProps) || this._isOnPreview(newProps);
    },

    _onResize() {
        let { socialBarActions } = this.props;
        let width = window.innerWidth;
        let height = window.innerHeight;

        clearTimeout(this.resizeTimeout);

        socialBarActions.resizeApp({width, height});

        this.resizeTimeout = setTimeout(() => {
            socialBarActions.resizeAppEnd();
        }, 100);
    }
});



// WEBPACK FOOTER //
// ./components/SocialBarAppContainer/SocialBarAppContainer.js